import React from "react";
import { TagRoom } from "@/components/TagRoom";

const HERO = "https://static.prod-images.emergentagent.com/jobs/0e3d4d61-ed21-4f86-b551-f282d91748f8/images/1963865d66e79864b9eb612fc2f0f10c2784d973f502210427eed4dfd0f2a8d4.jpeg";

export default function WadihitiGayakayo() {
  return <TagRoom titleKey="wg_title" subKey="wg_sub" heroImg={HERO} tag="elder" testid="wadihiti" />;
}
